import React, {PropsWithChildren} from 'react';

import {MuiThemeProvider,createMuiTheme} from '@material-ui/core';

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 16
  }
});


const ThemeProvider = ({children}: PropsWithChildren<any>) => {
  return (
    <MuiThemeProvider theme={theme}>
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;